export default "__VITE_ASSET__66e4f961__"